<script setup lang="ts">
import { ref } from "vue";
const { isMobile, isTablet, isDesktop } = useDevice();
import { ChevronDownIcon } from "@heroicons/vue/24/outline";

interface PostMenuItem {
   title: string;
   slug: string;
}

defineProps<{
   title: string;
   menus: PostMenuItem[];
}>();

const isOpen = ref(isMobile ? false : true);

const toggleDropdown = () => {
   if (isMobile) {
      isOpen.value = !isOpen.value;
   }
};

// state dropdown
</script>
<template>
   <div class="mt-4 border-t-[0.5px] pt-4 md:ml-6 md:mt-0 md:border-none">
      <div class="flex justify-between" @click="toggleDropdown">
         <h3 class="font-medium">{{ title }}</h3>
         <ChevronDownIcon
            :class="{ 'rotate-180': isOpen }"
            class="w-4 h-4 heroicon-sw-1 md:hidden"
         />
      </div>
      <ul class="mt-2 ml-4 md:ml-0" v-show="isOpen">
         <li v-for="item in menus">
            <NuxtLink :to="'/content/' + item.slug" class="text-white">{{
               item.title
            }}</NuxtLink>
         </li>
      </ul>
   </div>
</template>
